import React, { useState } from 'react';
import './ClientListDetail.css';
import { API_URL } from "../../utils/auth";
import CRSTrendChart from './CRSTrendChart';

const getStatus = (score) => {
    if (score >= 0 && score <= 3.99) return { color: 'at-risk', label: 'At-Risk' };
    if (score >= 4.0 && score <= 6.99) return { color: 'fair', label: 'Fair' };
    return { color: 'good', label: 'Good' };
};

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: 'short' };
    const month = date.toLocaleDateString('en-US', options);
    const day = date.getDate();
    const getDaySuffix = (day) => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };
    const year = date.getFullYear();
    return `${month} ${day}${getDaySuffix(day)} ${year}`;
};

const ClientListDetail = ({ client, onClick, showCheckbox, checked, onCheckboxChange }) => {
    const status = getStatus(client.clientRetentionScore);
    const [showProgramsModal, setShowProgramsModal] = useState(false);
    const programs = client.programs || [];
    const hasPrograms = programs.length > 0;
    const firstProgram = hasPrograms ? programs[0].description : null;
    const morePrograms = hasPrograms && programs.length > 1;

    return (
        <>
        <div className="client-list-detail" onClick={onClick}>
            {showCheckbox && (
                <div className="client-checkbox" onClick={e => e.stopPropagation()}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={onCheckboxChange}
                        aria-label="Select client"
                    />
                </div>
            )}
            <div className="client-name">
                {`${client.firstName || 'Unknown'} ${client.lastName || ''}`.trim()}
                <span className={`status ${status.color}`}>
                    &#9679; {status.label}
                </span>
            </div>
            <div className="client-company">
                {client.companyName || 'Unknown'}
            </div>
            <div className={`client-crs ${status.color}`}>
                {client.formattedCRS !== undefined ? client.formattedCRS : 'N/A'}
            </div>
            <div className="client-trend">
                <CRSTrendChart crsHistory={client.crsHistory} />
            </div>
            <div className="client-last-contacted">
                {client.lastContacted ? formatDate(client.lastContacted) : 'No data available'}
            </div>
            <div className="client-programs">
                {hasPrograms ? (
                    <>
                        <span>{firstProgram}</span>
                        {morePrograms && (
                            <button
                                className="see-more-programs-btn"
                                onClick={e => { e.stopPropagation(); setShowProgramsModal(true); }}
                            >
                                More
                            </button>
                        )}
                    </>
                ) : (
                    <span>No programs</span>
                )}
            </div>
            <div className="client-onboarding">
                {client.onboardingProgress !== null ? `${client.onboardingProgress}%` : 'Not Started'}
            </div>
        </div>
        {showProgramsModal && (
            <div className="programs-modal-overlay" onClick={() => setShowProgramsModal(false)}>
                <div className="programs-modal" onClick={e => e.stopPropagation()}>
                    <h3>Programs for {client.firstName} {client.lastName}</h3>
                    <ul>
                        {programs.map((p, idx) => (
                            <li key={p.id || idx}>{p.description}</li>
                        ))}
                    </ul>
                    <button onClick={() => setShowProgramsModal(false)} className="close-programs-modal-btn">Close</button>
                </div>
            </div>
        )}
        </>
    );
};

export default ClientListDetail;